import { createNamespacedHelpers } from "vuex";
// Store
const {
  mapActions: mapActionsOfCommons,
  mapMutations: mapMutationsOfCommons,
  mapState: mapStateOfCommons,
  mapGetters: mapGettersOfCommons
} = createNamespacedHelpers("sdfCommons");

export default {
  data() {
    return {};
  },
  computed: {
    ...mapStateOfCommons({
      vesselInfo: state => state.vesselInfo,
      ownVessels: state => state.ownVessels,
      maneuveringVersion: state => state.maneuveringVersion,
      engineVersion: state => state.engineVersion,
      alertVersion: state => state.alertVersion,
    }),
    ...mapGettersOfCommons(["getVesselId", "getChannelInfo", "hasChannelMaster"])
  },
  methods: {
    ...mapActionsOfCommons(["setVesselInfoAndVersions", "setChannelMaster", "setOwnVessels"]),
    ...mapMutationsOfCommons([])
  }
};
